import { TotalBalancesClientService } from '@client/application/ports';
import { getTotalBalances } from '@client/services/api/balances';

export default function useTotalBalancesClient(): TotalBalancesClientService {
  return {
    load: getTotalBalances,
  };
}
